module.exports = __webpack_public_path__ + "img/btn_keepGray.25709f88.svg";